import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Row, Card } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import { FaArrowLeft, FaEdit, FaPrint, FaSyncAlt } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import EditTransactionModal from './commonComponents/EditTransactionModal'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
// import { Typeahead } from 'react-bootstrap-typeahead'

export default function StudentFees() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()
  const location = useLocation()
  const {
    selectedStudent: navStudent,
    selectedFees: navFees,
    selectedData: navData,
    selectedStudentId: navStudentId,
    selectedClassId: navClassId,
    selectedCourseId: navCourseId,
  } = location.state || {}
  console.log('NAVIGATION DATA ', location.state)
  console.log('navStudent:', navStudent)
  console.log('navFees:', navFees)
  console.log('navData:', navData)
  console.log('navStudentId:', navStudentId)
  console.log('navClassId:', navClassId)
  console.log('navCourseId:', navCourseId)
  const { student_id, course_id } = useParams()
  const actualCourseId =
    course_id === 'null' || course_id === '_' ? null : course_id
  console.log('actualCourseId', actualCourseId)

  console.log('Student ID:', student_id)
  const [selectedFees, setSelectedFees] = useState([])
  const [openTable, setOpenTable] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [selectedData, setSelectedData] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedClassId, setSelectedClassId] = useState(null)
  const [hasModifiedFields, setHasModifiedFields] = useState(false)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [selectedStudentIdParams, setSelectedStudentIdParams] = useState(null)
  const [selectedTransactionId, setSelectedTransactionId] = useState(null)
  const [openEditModal, setOpenEditModal] = useState(null)
  
  const handleSelectFee = (feeId) => {
    setSelectedFees((prev) =>
      prev.includes(feeId)
        ? prev.filter((id) => id !== feeId)
        : [...prev, feeId],
    )
  }

      const fetchStudentFeeData = async () => {
      try {
        const res = await ApiEndpoints.getAllFeesByStudentProfileId(student_id)
        // console.log('student:', res.data.student)
        console.log('student:', res)

        console.log('fees:', res.data.fees)
        // console.log('selectedStudent:', res.data.selectedStudent)
        console.log('Response from params:', res.data.data)

        console.log('student_id', student_id)
        // setSelectedStudentIdParams(student_id)

        setSelectedStudentId(student_id)
        // setSelectedCourseId(course_id)
        // setSelectedClassId(class_id)

        setSelectedData(res.data.fees || res.data.data || [])

        setOpenTable(true)
      } catch (err) {
        console.error('Failed to fetch student fee data:', err)
        setSelectedData([])
        setOpenTable(true)
      }
    }

  useEffect(() => {
    if (navStudent && navData) {
      setSelectedStudent(navStudent)
      setSelectedData(navData)
      setOpenTable(true)
    } else if (student_id) {
      fetchStudentFeeData()
    }
  }, [navStudent, navData, student_id])

  useEffect(() => {
    if (navStudent) {
      setSelectedStudent(navStudent)
    }
    if (navFees) {
      setSelectedFees(navFees)
    }
    if (navData) {
      setSelectedData(navData)
      setOpenTable(true)
    }

    if (navStudentId || student_id) {
      setSelectedStudentId(navStudentId || student_id)
    }
    if (navClassId) {
      setSelectedClassId(navClassId)
    }
    if (navCourseId) {
      setSelectedCourseId(navCourseId)
    }
  }, [
    navStudent,
    navFees,
    navData,
    navStudentId,
    navCourseId,
    navClassId,
    student_id,
  ])

  useEffect(() => {
    if (student_id && selectedFees?.length > 0) {
      // const foundStudent = allStudents.find((s) => s.id === Number(student_id))
      // if (foundStudent) {
      //   setSelectedStudent(foundStudent)
      console.log('Student ID during fetch:', student_id)
      //   console.log('Course ID during fetch:', course_id)
      //   console.log('Class ID during fetch:', class_id)

      //   setSelectedCourseId(course_id)
      setSelectedStudentId(student_id)
      //   setSelectedClassId(class_id)
      setOpenTable(true)

      // Fetch fees
      ApiEndpoints.getAllFeesByStudentId(student_id)
        .then((res) => {
          setSelectedData(res.data.data)
        })
        .catch((error) => {
          console.error('Failed to load fees:', error)
          setSelectedData([])
        })
      // }
    }
  }, [student_id])

  //   useEffect(() => {
  //     if (selectedCourseId) {
  //       ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
  //         .then((res) => {
  //           const { data } = res
  //           if (data.status === false || !data.data?.length) {
  //             setClasses([])
  //           } else {
  //             setClasses(data.data)
  //             // setSelectedClassId(classId)
  //           }
  //         })
  //         .catch(() => {
  //           setClasses([])
  //         })
  //     }
  //   }, [selectedCourseId])
  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    // const fetchFilteredData = async () => {
    //   console.log('Insti ID: ', institueId)
    //   try {
    //     const headers = {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token}`,
    //       'institute-Id': Number(institueId),
    //     }

    //     console.log('Request Headers:', headers)

    //     const response = await axios.get(
    //       BASE_URL+'/student/all',
    //       { headers },
    //     )

    //     const studentRes = response.data.data
    //     console.log('Students response: ', studentRes)
    //     const studentId = student_id // the ID you want to search for
    //     const student = studentRes.find(
    //       (st) => Number(st.id) === Number(studentId),
    //     )
    //     const name = student || 'N/A'
    //     console.log('Select Student data:', name)
    //     const studentParId = studentRes.find(
    //       (st) => Number(st.id) === Number(student_id),
    //     )
    //     console.log('studentParId with data', studentParId)

    //     const studentParNameId = studentParId
    //     console.log('studentParId:', studentParNameId.id)
    //     console.log('studentParNameId:', studentParNameId?.name)

    //     setFilteredStudents(studentParId)
    //     setSelectedStudentIdParams(studentParId)

    //     setAllStudents(response.data.data)
    //     setSelectedStudent(name)
    //     // setData(response.data.data)
    //   } catch (error) {
    //     toast.error(error.response?.data?.message || 'Something went wrong')
    //   }
    // }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }
        console.log('Request Headers:', headers)

        const res = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = res.data.data
        console.log('Students response: ', students)

        const student =
          students.find((st) => Number(st.id) === Number(student_id)) || 'N/A'
        console.log('Select Student data:', student)

        const studentParId = students.find(
          (st) => Number(st.id) === Number(student_id),
        )
        console.log('studentParId with data', studentParId)
        console.log('studentParId:', studentParId?.id)
        console.log('studentParNameId:', studentParId?.name)

        setFilteredStudents(studentParId)
        setSelectedStudentIdParams(studentParId)
        setAllStudents(students)
        setSelectedStudent(student)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])
  //   useEffect(() => {
  //     ApiEndpoints.getAllCourses()
  //       .then((res) => setCourses(res.data.data))
  //       .catch(console.error)
  //   }, [])

  //   useEffect(() => {
  //     if (course_id) {
  //       handleCourseChange({ target: { value: course_id } })
  //     }
  //   }, [course_id])

  //   useEffect(() => {
  //     if (class_id && allStudents.length > 0) {
  //       handleClassChange({ target: { value: class_id } })
  //     }
  //   }, [class_id, allStudents])

  useEffect(() => {
    if (student_id && filteredStudents?.length > 0) {
      const student = filteredStudents.find((s) => s.id === Number(student_id))
      console.log('student ..........', student)

      if (student) {
        setSelectedStudentId(student.id)

        setSelectedStudent(student)
        // console.log('setSelectedStudentId', student.id)
        // console.log('setSelectedStudentIdParams', student.id)
        console.log('setSelectedStudent', student.id)
      }
    }
    // else if (selectedStudentIdParams && filteredStudents.length > 0) {
    //   const student = filteredStudents.find((s) => s.id === Number(student_id))
    //   console.log('student from params', student)
    // }
  }, [student_id, filteredStudents])

  useEffect(() => {
    if (!location.state) {
      // Hard refresh happened - clear everything manually
      setSelectedStudent(null)
      setSelectedFees([])
      setSelectedData([])
      setSelectedCourseId(null)
      setSelectedClassId(null)
      setSelectedStudentId(null)
      setOpenTable(false)
    }
  }, [location.state])

  //   const handleCourseChange = async (e) => {
  //     setHasModifiedFields(true)
  //     const courseId = e.target.value
  //     setSelectedCourseId(courseId)
  //     setClasses([])
  //     setFilteredStudents([])
  //     setSelectedData([])
  //     setSelectedStudentId(null)
  //     setSelectedClassId(null)
  //     setSelectedStudent(null)

  //     // console.log('courseId ', courseId, 'and', 'course_id', course_id)
  //     setOpenTable(true)
  //     if (courseId) {
  //       const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
  //       setClasses(res.data.data)
  //     }
  //     if (courseId) {
  //       ApiEndpoints.getAllClassesByCourseId(courseId)
  //         .then((res) => {
  //           const { data } = res
  //           if (data.status === false || !data.data?.length) {
  //             toast.error('No classes found for this course.')
  //             setClasses([])
  //             setOpenTable(false)
  //           } else {
  //             setClasses(data.data)
  //           }
  //         })
  //         .catch((error) => {
  //           // This is where 404 or other errors come
  //           if (
  //             error.response?.data?.message === 'No classes found for this course'
  //           ) {
  //             toast.error('No classes found for this course.')
  //           } else {
  //             console.error('Error fetching classes:', error)
  //             toast.error('Something went wrong while fetching classes.')
  //           }
  //           setClasses([])
  //         })
  //     }
  //   }

  //   const handleClassChange = (e) => {
  //     setHasModifiedFields(true)
  //     const classId = e.target.value

  //     const filtered = allStudents.filter(
  //       (student) => student.class_id === Number(classId),
  //     )
  //     console.log('filtered', filtered)
  //     // setFilteredStudents(filtered)
  //     setSelectedClassId(classId)
  //     setSelectedStudentId(null)
  //     setSelectedStudent(null)
  //     setSelectedData([])
  //     setSelectedFees([])
  //     setOpenTable(true)

  //     if (classId) {
  //       const institueId = Cookies.get('institute_id')
  //       const headers = {
  //         'institute-Id': Number(institueId),
  //       }
  //       axios
  //         .get(
  //           BASE_URL+`/get/student/by-class?class_id=${classId}`,
  //           { headers },
  //         )
  //         .then((res) => {
  //           console.log('Students after class select:', res.data.data)
  //           setFilteredStudents(res.data.data)
  //         })
  //         .catch((error) => {
  //           // This is where 404 or other errors come
  //           if (
  //             error.response?.data?.message === 'No classes found for this course'
  //           ) {
  //             console.error('No classes found for this course.')
  //           } else {
  //             console.error('Error fetching classes:', error)
  //             console.error('Something went wrong while fetching classes.')
  //           }
  //           setClasses([])
  //         })
  //     }
  //   }
  useEffect(() => {
    if (selectedCourseId && selectedStudentId) {
      ApiEndpoints.getAllFeesByStudentProfileId(student_id)
        .then((res) => {
          console.log('Response:', res.data.data)
          setSelectedData(res.data.data)
          setOpenTable(true)
        })
        .catch((err) => {
          console.error('Failed to fetch fees', err)
          setSelectedData([])
        })
    }
    // }
  }, [student_id])

  //   const handleStudentChange = async (e) => {
  //     setHasModifiedFields(true)
  //     const studentId = e.target.value
  //     setSelectedStudentId(studentId)
  //     // setOpenTable(true)
  //     const student = filteredStudents.find((s) => s.id === Number(studentId))
  //     setSelectedStudent(student)
  //     setSelectedFees([])
  //     setOpenTable(true)

  //     if (selectedStudentId && selectedCourseId) {
  //       try {
  //         const res = await ApiEndpoints.getAllFeesByStudentId(
  //           selectedStudentId,
  //           selectedCourseId,
  //         )
  //         console.log('Last response:', res.data.data)

  //         setSelectedData(res.data.data) // Store fees data properly
  //       } catch (error) {
  //         console.error('Error fetching fees:', error.response?.data?.message)
  //         // toast.error(error.response?.data?.message)
  //         setSelectedData([])
  //       }
  //     }
  //   }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const navigate = useNavigate()
  const handlePrint = (fee) => {
    if (!selectedStudent && !selectedStudentIdParams?.id) {
      toast.error('Select a student to print the receipt.')
      return
    }

    const studentId = selectedStudent?.id || student_id
    const feeIdsParam = selectedFees.length ? selectedFees.join(',') : fee?.id

    const stateData = {
      fee,
      selectedStudent,
      selectedFees: selectedFees.length ? selectedFees : [fee?.id],
      selectedData,
      selectedCourseId,
      selectedClassId,
      selectedStudentId,
      selectedStudentIdParams,
    }
    console.log('State Data:', stateData)
    navigate(`/FeeRecipt/${studentId}/${feeIdsParam}`, {
      state: stateData,
    })
  }

  const handleBack = (studentId) => {
    if (!studentId) {
      toast.error('No student selected. Please select a student first')
      return
    }
    navigate(`/student/profile/${studentId}`)
  }

  const handleTakeFeesButton = () => {
    if (!student_id) {
      toast.error('Student is not selected')
      return
    }

    if (!selectedCourseId) {
      // If course is optional, you can still navigate with just studentId
      navigate(`/TakeFees/${student_id}`)
    } else {
      // Full route with both course and student
      navigate(`/TakeFees/${actualCourseId}/${student_id}`)
    }
  }

  console.log('selectedStudentId:', selectedStudentId)
  console.log('selectedCourseId:', selectedCourseId)
  console.log('selectedStudentIdParams:', selectedStudentIdParams?.id)
  console.log('selectedStudentIdParamsName:', selectedStudentIdParams?.name)

  console.log('student_id:', student_id)

  const visibleFees = Array.isArray(selectedData)
    ? selectedData
        .filter(
          (fee) =>
            fee.fees_status === 'pending' || fee.fees_status === 'complete',
        )
        .sort((a, b) => {
          // Pending fees first, then completed
          if (a.fees_status === b.fees_status) return 0
          if (a.fees_status === 'pending') return -1
          if (b.fees_status === 'pending') return 1
          return 0
        })
    : []

  return (
    <>
      <style>
        {`
        .hover-white:hover{
        color:white !important;
        }
      `}
      </style>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '62px' : '12px',
          paddingRight: isCollapsed ? '62px' : '12px',
        }}
      >
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                // width: '100%',
              }}
            >
              <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>

                <div>
                  <h3
                    className="m-0 fw-bold text-start"
                    style={{
                      letterSpacing: '-0.02em',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: 'clamp(18px, 2.5vw, 22px)',
                      color: '#223843',
                      lineHeight: '1.2',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    Fees
                  </h3>
                  <p
                    className="m-0 mt-1 text-start"
                    style={{
                      fontSize: window.innerWidth < 768 ? '11px' : '13px',
                      color: '#6b7280',
                      fontWeight: '400',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    See student fees
                    {(selectedStudent?.name || selectedStudentIdParams?.name) ? (
                      <>
                        {' '}
                        for{' '}
                        <span style={{ fontWeight: 600 }}>
                          {selectedStudent?.name || selectedStudentIdParams?.name}
                        </span>
                        .
                      </>
                    ) : (
                      '.'
                    )}
                  </p>
                </div>
              </div>

              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>

        {/* <div className="d-flex flex-nowrap gap-3">

      </div> */}

        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {openTable && (
            <div className="text-start">
              <div className="d-flex justify-content-between align-items-center mb-3">
              {/* {student_id && (
                <div>
                  <Button onClick={() => handleBack(selectedStudent?.id)}>
                    <FaArrowLeft /> Go to{' '}
                    <span className="fw-bold">{selectedStudent?.name}</span>{' '}
                    profile
                  </Button>
                </div>
              )} */}

              {/* <div className="ms-auto gap-2 d-flex">
                <Button
                  variant="outline-dark"
                  className="text-danger fw-bold hover-white"
                  onClick={() => handleTakeFeesButton()}
                  // disabled={selectedData.length === 0}
                >
                  💰 Take Fees
                </Button>
                <button
                  onClick={() => handlePrint()}
                  className="btn btn-primary"
                  disabled={selectedFees.length === 0}
                >
                  <FaPrint className="me-2" />
                  Print Receipt
                </button>
              </div> */}
            </div>
              <Card
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  backgroundColor: '#ffffff',
                }}
              >
                <Table
                  className="table mb-0"
                  style={{ borderRadius: '12px', overflow: 'hidden' }}
                >
                  <Thead>
                    <Tr style={{ backgroundColor: '#F3F4F6' }}>
                  {/* <th>Select Rows</th> */}
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Fees Name
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Course
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Amount in Rupees
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif', whiteSpace: 'nowrap' }}>
                        Start Date
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif', whiteSpace: 'nowrap' }}>
                        End Date
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Transaction ID
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Transaction Amount
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Discount
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        Payment Method
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif', whiteSpace: 'nowrap' }}>
                        Transaction Date
                      </Th>
                      <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif', whiteSpace: 'nowrap' }}>
                        Fees Status
                      </Th>
                  {/* <th>Action</th> */}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {/* Check if a student is selected */}
                    {!student_id && selectedData.length === 0 ? (
                      <Tr>
                        <Td
                          colSpan={11}
                          className="text-center text-danger"
                          style={{
                            padding: '40px',
                            fontSize: '14px',
                            color: '#6b7280',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            border: 'none',
                          }}
                        >
                          No data found
                        </Td>
                      </Tr>
                    ) : visibleFees.length === 0 ? (
                      <Tr>
                        <Td
                          colSpan={11}
                          className="text-center"
                          style={{
                            padding: '40px',
                            fontSize: '14px',
                            color: '#6b7280',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            border: 'none',
                          }}
                        >
                          No fees available
                        </Td>
                      </Tr>
                    ) : (
                      visibleFees.map((fee, index) => (
                          <Tr
                            key={fee.id}
                            style={{
                              backgroundColor:
                                index % 2 === 0
                                  ? '#ffffff'
                                  : 'rgba(243, 244, 246, 0.4)',
                            }}
                          >
                        {/* <td className="text-center">
                          {fee.fees_status === 'complete' && (
                            <input
                              style={{
                                cursor: 'pointer',
                                width: '20px',
                                height: '20px',
                              }}
                              type="checkbox"
                              onChange={() => handleSelectFee(fee.id)} // Update to select individual fees
                              checked={selectedFees.includes(fee.id)} // Check if this fee is selected
                            />
                          )}
                        </td> */}

                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                fontWeight: '600',
                              }}
                            >
                          {fee.fees_name?.charAt(0).toUpperCase() +
                            fee.fees_name?.slice(1)}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#374151',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                              }}
                            >
                              {fee.course_name}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              ₹ {fee.amount}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          {new Date(fee.start_date).toLocaleDateString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            },
                          )}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          {new Date(fee.end_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                              }}
                            >
                              {fee.transaction_id || ''}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          {fee.transaction_amount
                            ? `₹${fee.transaction_amount}`
                            : ' '}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {fee.discount ? `₹${fee.discount}` : ''}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          {fee.payment_method
                            ? fee.payment_method.charAt(0).toUpperCase() +
                              fee.payment_method.slice(1)
                            : 'N/A'}
                            </Td>

                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          {fee.transaction_date
                            ? new Date(fee.transaction_date).toLocaleDateString(
                                'en-GB',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                },
                              )
                            : null}
                            </Td>
                            <Td
                              style={{
                                fontSize: '14px',
                                padding: '16px',
                                border: 'none',
                                color: '#111827',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                              }}
                            >
                          <span
                            className="fw-bold"
                            style={{
                              backgroundColor:
                                fee.fees_status === 'complete'
                                  ? '#d1fae5'
                                  : '#fef3c7', // green or yellow background
                              color:
                                fee.fees_status === 'complete'
                                  ? '#065f46'
                                  : '#92400e', // dark green or dark orange text
                              padding: '4px 10px',
                              borderRadius: '20px',
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              textTransform: 'capitalize',
                            }}
                          >
                            {fee.fees_status}
                          </span>
                            </Td>
                        {/* <td>
                          <button onClick={()=>{
                            console.log("Selected fees id for edit:", fee.id)
                            setSelectedTransactionId(fee.id)
                            setOpenEditModal(true)
                          }} title="Edit Fees" className='btn btn-warning' variant="warning">
                            <FaEdit  />
                          </button>
                        </td> */}

                        {/* <td className="text-end">
                      {fee.fees_status === 'complete' &&
                        (selectedFees.length > 1 ? (
                          // Show print button only on the first selected row
                          selectedFees[0] === fee.id && (
                            <button
                              title="Print Selected"
                              onClick={handlePrint}
                              className="btn btn-sm btn-primary "
                            >
                              <FaPrint />
                            </button>
                          )
                        ) : (
                          // Show individual print button for single selection
                          <button
                            title="Print"
                            onClick={() => handlePrint(fee)}
                            className="btn btn-sm btn-primary"
                          >
                            <FaPrint />
                          </button>
                        ))}
                    </td> */}
                          </Tr>
                        ))
                    )}
                  </Tbody>
                </Table>
              </Card>
            </div>
          )}
        </div>
      </div>
      <EditTransactionModal show={openEditModal}
        data={selectedData}
        selectedId={selectedTransactionId}
      onHide={()=>setOpenEditModal(false)} 
      onUpdate={fetchStudentFeeData}
        />
    </>
  )
}
